import { render } from "./AuthCarsouel.vue?vue&type=template&id=63ef00d5"
import script from "./AuthCarsouel.vue?vue&type=script&lang=js"
export * from "./AuthCarsouel.vue?vue&type=script&lang=js"

import "./AuthCarsouel.vue?vue&type=style&index=0&id=63ef00d5&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__